import { SvgIcon, type SvgIconProps } from '@mui/material';

export const PrintsMenuIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props} style={{ overflow: 'visible', ...props.style }}>
		<path id="Rectangle_2048" fill="none" d="M0 0h26v26H0z" data-name="Rectangle 2048" />
		<path
			id="_Color"
			fill="currentColor"
			d="M5.26 0 2.98 2.272.7 0 0 .7l2.98 2.975L5.96.7Z"
			data-name="↳Color"
			transform="translate(23.281 19.824)"
		/>
		<g id="Group_8098" data-name="Group 8098" transform="translate(2.202 3.114)">
			<g id="Group_8042" data-name="Group 8042">
				<g id="Group_8037" data-name="Group 8037">
					<g id="r2me">
						<g id="Layer_2">
							<g id="Group_8036" fill="none" stroke="currentColor" strokeWidth="1" data-name="Group 8036">
								<path
									id="Path_8226"
									d="M17.752 6.551h-5.711l4.975-1.471a.847.847 0 0 0 .562-1.038.88.88 0 0 0-1.038-.519L9.618 5.556V3.7a.98.98 0 0 0-1-1H2.7a1.006 1.006 0 0 0-1 1v5.447h17.09V7.589a1.053 1.053 0 0 0-1.038-1.038Z"
									data-name="Path 8226"
									transform="translate(-1.7 -2.7)"
								/>
								<path
									id="Path_8227"
									d="M10.363 40.571H8.925a1.57 1.57 0 0 1-1.6-1.471H1.7v3.029a.98.98 0 0 0 1 1h8.932a6.6 6.6 0 0 1-.795-1.241 9 9 0 0 1-.474-1.317Z"
									data-name="Path 8227"
									transform="translate(-1.7 -23.351)"
								/>
								<path
									id="Path_8228"
									d="M1.7 26.319h8.523a6.13 6.13 0 0 1 1.663-4A8.7 8.7 0 0 1 15.415 20H1.7Z"
									data-name="Path 8228"
									transform="translate(-1.7 -12.04)"
								/>
							</g>
						</g>
					</g>
					<path
						id="Union_42"
						fill="currentColor"
						d="M7.136 7.657H1.3A1.3 1.3 0 0 1 0 6.36V1.3A1.3 1.3 0 0 1 1.3 0h5.836a1.3 1.3 0 0 1 1.3 1.3v5.06a1.3 1.3 0 0 1-1.3 1.297M2.853 3.98a1.08 1.08 0 0 0-.909 1.168V6.4h4.5V5.148a1.05 1.05 0 0 0-.908-1.168ZM4.195 1.3a1.3 1.3 0 1 0 1.3 1.3 1.326 1.326 0 0 0-1.3-1.3"
						data-name="Union 42"
						transform="translate(11.162 11.813)"
					/>
				</g>
				<path
					id="Union_46"
					fill="currentColor"
					d="M0 2.812V2.7a2.7 2.7 0 0 1 5.408 0v.108ZM.868 2.6H4.54a1.839 1.839 0 0 0-3.672 0"
					data-name="Union 46"
					transform="translate(12.675 9.108)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const PrintsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props} style={{ overflow: 'visible', ...props.style }}>
		<path id="Rectangle_3378" fill="none" d="M0 0h26v26H0z" data-name="Rectangle 3378" />
		<g id="Group_8107" data-name="Group 8107" transform="translate(-494 -1790.57)">
			<g id="Group_8108" data-name="Group 8108" transform="translate(.3 1.2)">
				<g id="Group_4722" data-name="Group 4722" transform="translate(435.499 816.569)">
					<path
						id="Subtraction_10"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="0.25"
						d="M14085.121-6126.569h-17.243a1.857 1.857 0 0 1-1.877-1.877 7.2 7.2 0 0 1 .329-1.99c.325-1.41 3.327-2.479 6.522-3.426l.442-.11c.2-.1.545-.824.664-2.1a3.15 3.15 0 0 1-.884-1.106.6.6 0 0 1-.114-.169.6.6 0 0 0-.108-.164 6 6 0 0 1-.774-1.435 3 3 0 0 1-.658-.549 5.6 5.6 0 0 1-.667-2.99 1.33 1.33 0 0 1 .551-.552 6.13 6.13 0 0 1 1.439-4.31v-.223a1.82 1.82 0 0 1 1.549-1.1.86.86 0 0 1 .105-.442 1.53 1.53 0 0 1 .778-.884h.007a.4.4 0 0 1 .321.11l.223.219c0 .113.217.222.661.332a15 15 0 0 1 1.653.541h.01l.027.01c.12.045.223.084.3.11 2.008.777 3.206 2.884 3.206 5.635a.9.9 0 0 1 .55.548 5.4 5.4 0 0 1-.55 2.991 1.36 1.36 0 0 1-.551.552 6.5 6.5 0 0 1-.468.892l-.008.013c-.118.2-.215.362-.3.53a.57.57 0 0 0-.223.442 4 4 0 0 1-.755.978l-.02.02a3.2 3.2 0 0 0 .552 2.1c.417.165.9.331 1.422.493l-.287.979c-.674-.2-1.127-.344-1.468-.479-1.154-.525-1.213-2.669-1.213-3.094v-.445l.333-.329.018-.018a2.5 2.5 0 0 0 .424-.537 1.25 1.25 0 0 1 .333-.771.8.8 0 0 1 .219-.442 2 2 0 0 0 .361-.6l.01-.022.071-.151.223-.332.328-.223.11-.11a4.46 4.46 0 0 0 .555-1.99l-.665-.219v-.774a5.95 5.95 0 0 0-.69-2.941 3.88 3.88 0 0 0-1.852-1.7.54.54 0 0 1-.327-.109 6.6 6.6 0 0 0-1.549-.555 1.6 1.6 0 0 1-.529-.133l-.02-.007-.226-.079v.774l-.884.219a1.2 1.2 0 0 0-.665.223v.442l-.328.333a4.8 4.8 0 0 0-1.106 3.535v.665l-.552.329a3.57 3.57 0 0 0 .552 1.881l.219.219.332.223.223.442a3.5 3.5 0 0 0 .539 1.087l.013.019.013.013c.1.1.21.21.21.316l.11.113a2.8 2.8 0 0 0 .551.771l.556.333-.113.665c0 .987-.377 2.565-1.217 2.984h-.219l-.442.109c-3.6 1.122-5.536 2.014-5.748 2.652a4.5 4.5 0 0 0-.332 1.658.75.75 0 0 0 .773.774h17.353a.75.75 0 0 0 .774-.774c0-.091 0-.178-.008-.276h1c.009.137.009.259.009.389a1.86 1.86 0 0 1-1.883 1.874Z"
						data-name="Subtraction 10"
						transform="translate(-14006.5 7124)"
					/>
				</g>
				<path
					id="secure-print-icon"
					fill="currentColor"
					d="M20.518 22.9a4.23 4.23 0 0 1-2.531-1.726 4.95 4.95 0 0 1-.92-3.106v-2.3l3.567-1.726 3.566 1.723v2.3a5.8 5.8 0 0 1-.92 3.106 4.23 4.23 0 0 1-2.532 1.729Zm-.575-2.646 3.106-3.106-.92-.92-2.186 2.186-.92-.92-.92.92 1.726 1.726Z"
					transform="translate(494.184 1787.63)"
				/>
			</g>
		</g>
	</SvgIcon>
);

export const ManagedPrintsIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props} style={{ overflow: 'visible', ...props.style }}>
		<path id="Rectangle_2027" fill="none" d="M0 0h26v26H0z" data-name="Rectangle 2027" />
		<g id="task-pool" transform="translate(3.147 3.148)">
			<path id="Path_6725" fill="none" d="M0 0h19.7v19.7H0Z" data-name="Path 6725" />
			<path
				id="Path_6726"
				fill="currentColor"
				d="M14.749 1H3.821A1.77 1.77 0 0 0 2 2.7v11.932h1.821V2.7h10.928Zm-.911 3.408H7.464a1.77 1.77 0 0 0-1.821 1.7V18.04a1.77 1.77 0 0 0 1.821 1.7h10.017a1.77 1.77 0 0 0 1.821-1.7V9.52ZM7.464 18.04V6.112h5.464v4.26h4.553v7.668Z"
				data-name="Path 6726"
				transform="translate(-1.039 -.519)"
			/>
		</g>
		<path
			id="video_settings_FILL0_wght400_GRAD0_opsz24"
			fill="currentColor"
			d="m2.414 6.27-.188-.94q-.188-.078-.353-.165a3 3 0 0 1-.337-.212l-.909.282L0 4.17l.721-.627a3 3 0 0 1-.031-.408 3 3 0 0 1 .031-.408L0 2.1l.627-1.065.909.282a3 3 0 0 1 .337-.212q.165-.086.353-.165L2.414 0h1.254l.188.94a3 3 0 0 1 .353.172 2.5 2.5 0 0 1 .337.235l.909-.314.627 1.1-.721.627a2.5 2.5 0 0 1 0 .784l.721.627-.627 1.064-.909-.282a3 3 0 0 1-.337.212q-.165.086-.353.165l-.188.94Zm.627-1.881a1.26 1.26 0 0 0 1.254-1.254 1.26 1.26 0 0 0-1.254-1.254 1.26 1.26 0 0 0-1.254 1.254 1.26 1.26 0 0 0 1.254 1.254"
			transform="rotate(164 7.472 10.752)"
		/>
	</SvgIcon>
);

export const DirectPrintIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<rect id="Rectangle_3925" data-name="Rectangle 3925" fill="none" />
		<path
			d="M3.868,15.264l1.8-1.783H0V12.016H5.669l-1.8-1.8,1.04-1.03,3.6,3.561-3.6,3.561Zm4.316,1.045L9.5,14.843h5.363V10.672H9.334L7.966,9.206h8.372v1.729H18.52v-4.1a.941.941,0,0,0-.284-.7.959.959,0,0,0-.7-.281H4.291a.913.913,0,0,0-.7.311A1.044,1.044,0,0,0,3.3,6.9V8.463H1.825V6.839A2.352,2.352,0,0,1,2.534,5.1a2.4,2.4,0,0,1,1.757-.7h1.2V0H16.338V4.4h1.2a2.4,2.4,0,0,1,1.75.7A2.34,2.34,0,0,1,20,6.839V12.4H16.338v3.908ZM14.859,4.4V1.465H6.966V4.4Z"
			transform="translate(2.5 3.846)"
			fill="currentColor"
		/>
	</SvgIcon>
);

export const UploadPrintIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" />
	</SvgIcon>
);

export const UploadPrintDescriptionIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			id="Union_52"
			fill="currentColor"
			d="M14020.25 1220a2.26 2.26 0 0 1-2.251-2.251v-3.375h2.251v3.375h13.5v-3.375h2.25v3.375a2.257 2.257 0 0 1-2.25 2.251Zm5.626-4.5v-9.19l-2.913 2.9-1.589-1.585L14027 1202l5.626 5.625-1.585 1.585-2.913-2.9v9.19Z"
			data-name="Union 52"
			transform="translate(-14014.998 -1199)"
		/>
		<path id="Rectangle_3748" fill="none" d="M0 0h24v24H0z" data-name="Rectangle 3748" />
	</SvgIcon>
);

export const PrintGroupTitleIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path
			d="M16,1H4C2.9,1,2,1.9,2,3v14h2V3h12V1z M15,5H8C6.9,5,6,5.9,6,7l0,14c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2V11L15,5z M8,21V7h6
	v5h5v9H8z"
		/>
		<polygon points="10.3,14.6 8.9,16 12.4,19.5 18.1,13.9 16.7,12.4 12.4,16.7 " />
	</SvgIcon>
);

export const SecurePrintIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<defs>
			<clipPath id="clip-path">
				<rect
					id="Rectangle_3377"
					data-name="Rectangle 3377"
					width="8.646"
					height="8.646"
					transform="translate(0 0)"
					fill="#23ac2e"
				/>
			</clipPath>
		</defs>
		<rect id="Rectangle_3376" data-name="Rectangle 3376" width="26" height="26" fill="none" />
		<g id="Group_8106" data-name="Group 8106" transform="translate(-885 -491)">
			<path
				id="secure-print-icon"
				d="M4.526,10.7h0Zm2.531,12.31v-4.6H2.8V11.853A2.759,2.759,0,0,1,5.676,8.977H21.093a2.759,2.759,0,0,1,2.876,2.876v1.5c-.23-.115-.381-.255-.805-.46a5.634,5.634,0,0,0-.92-.345v-.69c0-.345,0-.575-.345-.805s-.46-.345-.805-.345H5.676c-.345,0-.575,0-.805.345a1.044,1.044,0,0,0-.345.805v4.832H7.057V14.615h8.549a4.109,4.109,0,0,0-.662.812,3.432,3.432,0,0,0-.469.914H8.783v4.947h5.692a1.552,1.552,0,0,0,.376.91,4.971,4.971,0,0,0,.755.816ZM17.987,8.977V5.526h-9.2V8.977H7.057V3.8H19.712V8.977Z"
				transform="translate(884.5 490.63)"
				fill="#23ac2e"
			/>
			<g id="Group_8105" data-name="Group 8105" transform="translate(899.709 505)">
				<g id="Group_8104" data-name="Group 8104" transform="translate(0 0)" clipPath="url(#clip-path)">
					<path
						id="Path_8235"
						data-name="Path 8235"
						d="M4.323,8.646a4.222,4.222,0,0,1-1.69-.34A4.312,4.312,0,0,1,.34,6.013,4.222,4.222,0,0,1,0,4.323a4.222,4.222,0,0,1,.34-1.69A4.312,4.312,0,0,1,2.633.34,4.222,4.222,0,0,1,4.323,0,4.283,4.283,0,0,1,5.591.184,4.375,4.375,0,0,1,6.706.707l-.8.813a3.49,3.49,0,0,0-.749-.314,2.993,2.993,0,0,0-.832-.113,3.118,3.118,0,0,0-2.286.941,3.112,3.112,0,0,0-.944,2.289,3.111,3.111,0,0,0,.944,2.289,3.117,3.117,0,0,0,2.286.941,3.118,3.118,0,0,0,2.286-.941,3.111,3.111,0,0,0,.944-2.289q0-.149-.015-.3a2.784,2.784,0,0,0-.044-.289l.9-.9a4.316,4.316,0,0,1,.19.718,4.414,4.414,0,0,1,.065.763,4.228,4.228,0,0,1-.34,1.692A4.312,4.312,0,0,1,6.013,8.306a4.222,4.222,0,0,1-1.69.34m-.6-2.309L1.887,4.5l.735-.74L3.728,4.861,7.9.674l.741.741Z"
						transform="translate(0 0)"
						fill="#23ac2e"
					/>
				</g>
			</g>
		</g>
	</SvgIcon>
);
